import { createSlice } from "@reduxjs/toolkit"

const initialStateResultadoGrillaFactura= {
  dataGrillaFactura: []
}; 

export const resultadoGrillaFacturaSlice = createSlice({ 
  name: "resultadoGrillaFactura", 
  initialState: initialStateResultadoGrillaFactura, 
  reducers:{
    setResultadoGrilla: (state, action)=>{
      state.dataGrillaFactura=action.payload
    },
    resetResultadoGrilla: (state) => {
      state.dataGrillaFactura=initialStateResultadoGrillaFactura.dataGrillaFactura
    }
  }
});

export const {resetResultadoGrilla, setResultadoGrilla} = resultadoGrillaFacturaSlice.actions
export default resultadoGrillaFacturaSlice.reducer
